import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useTranslation } from 'react-i18next';
import ChannelConfirmationContainer from './channel-confirmation-container';
import { colors, TextDescription, DisableNotificationIcon } from '@aftersale-next/ui';
import { useNotificationDisable } from '../../hooks/use-disable-notifications';
import { useAppMode } from '../../hooks/use-app-mode';
import { useChannelSelection } from '../../hooks/use-channel-selection';
export default function DisableNotificationConfirmation() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useAppMode = useAppMode(),
      _useAppMode2 = _slicedToArray(_useAppMode, 2),
      setMode = _useAppMode2[1];

  var _useChannelSelection = useChannelSelection(),
      _useChannelSelection2 = _slicedToArray(_useChannelSelection, 2),
      setSelected = _useChannelSelection2[1];

  var mutation = useNotificationDisable({
    onSuccess: function onSuccess() {
      setMode('tracking');
      setSelected('');
    }
  });
  return /*#__PURE__*/_jsx(ChannelConfirmationContainer, {
    name: "not-disturb",
    label: t('NOT_NOTIFY'),
    isLoading: mutation.isLoading,
    icon: /*#__PURE__*/_jsx(DisableNotificationIcon, {}),
    iconBgColor: colors.gray,
    handleConfirm: function handleConfirm() {
      return mutation.mutate();
    },
    children: /*#__PURE__*/_jsx(TextDescription, {
      center: true,
      children: t('NOT_DISTURB_CONFIRMATION')
    })
  });
}